(function ($, w, d, h, b) {

    var app = {

        initVideo: function () {
			$('.ip-about-video a').on('click', function(e) {
                e.preventDefault();
            
                var $this = $(this);
                if (!$this.parent().hasClass('is-playing')) {
                    // Remove any existing playing classes and videos
                    $('.ip-about-video a').parent().removeClass('is-playing');
                    $('.ip-about-video .site-img video').remove();
            
                    // Append new video and play it
                    var $video = $('<video preload="none" autoplay src="' + $this.attr('href') + '"></video>');
                    $video.appendTo($this.parent().find('.site-img'));
                    $this.parent().addClass('is-playing');
                    $video[0].play();
            
                    // Add event listener for when the video ends
                    $video.on('ended', function() {
                        // Additional functionality after video ends
                        $this.parent().removeClass('is-playing is-paused');
                    });
                } else {
                    var $videoElement = $this.parent().find('.site-img video')[0];
                    if (!$this.parent().hasClass('is-paused')) {
                        // Pause the video
                        $videoElement.pause();
                        $this.parent().addClass('is-paused');
                    } else {
                        // Play the video
                        $videoElement.play();
                        $this.parent().removeClass('is-paused');
                    }
                }
            });
		},
    }

    $(document).ready( function() {
        app.initVideo();
    });
    
    $(window).on('load', function(){

    });

})(jQuery, window, document, 'html', 'body');